import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  FontFamily,
  FontWeight,
  Text,
} from '@gousto-internal/citrus-react'

import type { StandardRecipeItem } from '@library/api-menu-experience'

type SubtitleTagRowProps = {
  recipe: StandardRecipeItem
}

export const SubtitleTagRow = ({ recipe }: SubtitleTagRowProps) => {
  const subtitleTags = recipe.tagGroups.subtitle ?? []

  if (subtitleTags.length === 0) {
    return null
  }

  return (
    <Box
      data-testid="recipe-tile-metadata"
      display={Display.Flex}
      alignItems={AlignItems.Center}
      gap={1}
      wrap
    >
      {subtitleTags.map((tag, index) => (
        <React.Fragment key={`${tag.type}-${tag.text}`}>
          {index > 0 ? (
            <Text
              aria-hidden="true"
              size={2}
              fontFamily={FontFamily.Book}
              fontWeight={FontWeight.Normal}
              color={Color.ColdGrey_600}
            >
              •
            </Text>
          ) : null}
          <Box
            color={Color.ColdGrey_600}
            display={Display.Flex}
            alignItems={AlignItems.Center}
            gap={1}
          >
            <Text
              size={2}
              fontFamily={FontFamily.Book}
              fontWeight={FontWeight.Normal}
              color={Color.Inherit}
            >
              {tag.text}
            </Text>
          </Box>
        </React.Fragment>
      ))}
    </Box>
  )
}
